<script lang="ts">
    export let type: 'naked' | 'primary' | 'secondary';
    export let color: 'dark' | 'light' = 'dark';
    export let title: string;
    export let url: string;
    export let withArrow: boolean = false;
</script>

{#if type === 'naked'}
    <a href={url} class="text-sm font-semibold leading-6" class:text-copy-500={color === 'dark'} class:text-base-100={color === 'light'}>
        {title} <span aria-hidden="true">→</span>
    </a>
{:else if type === 'secondary'}
    <a href={url}
       class="rounded-md bg-secondary-500 hover:bg-primary-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm">
        {title}
        {#if withArrow}
            <span aria-hidden="true">→</span>
        {/if}
    </a>
{:else}
    <a href={url}
       class="rounded-md bg-primary-500 hover:bg-primary-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm">
        {title}
        {#if withArrow}
            <span aria-hidden="true">→</span>
        {/if}
    </a>
{/if}
